<template>
  <b-modal
    id="splash-screen-form"
    :title="splashScreen ? 'Edit Splash Screen' : 'Add Splash Screen'"
    hide-footer
    size="xl"
    @shown="shownHandler"
    @hidden="hiddenHandler"
  >
    <b-card>
      <validation-observer ref="formRef">
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center mb-2"
          >
            <b-button
              :disabled="submitting"
              variant="primary"
              @click="submitForm"
            >
              <b-spinner v-if="submitting" small />
              <span v-else>Submit Splash Screen</span>
            </b-button>
          </b-col>
          <b-col md="12">
            <b-form-group label="Attachments">
              <h6 class="mb-3">
                Upload 4 different screen sizes:
              </h6>
              <b-row>
                <!-- 1080x1920 Upload -->
                <b-col md="6">
                  <div class="mb-3">
                    <label class="form-label">1080x1920</label>
                    <FileUpload
                      ref="fileUploadRef1080x1920"
                      :allowed-extensions="allowedExtensions"
                      @file-uploaded="updateKey($event, '1080x1920')"
                    />
                    <div v-if="getPreviewAttachment('1080x1920')" class="mt-2">
                      <div
                        class="preview-container"
                        v-if="splashScreen && isImageKey('1080x1920')"
                      >
                        <img
                          :src="getPreviewAttachment('1080x1920')"
                          alt="1080x1920 preview"
                          class="key-preview-image"
                        />
                      </div>
                      <b-button
                        class="mt-1"
                        variant="outline-primary"
                        size="sm"
                        @click="viewAttachment('1080x1920')"
                      >
                        View 1080x1920
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <!-- 1080x2160 Upload -->
                <b-col md="6">
                  <div class="mb-3">
                    <label class="form-label">1080x2160</label>
                    <FileUpload
                      ref="fileUploadRef1080x2160"
                      :allowed-extensions="allowedExtensions"
                      :size="{ width: 1080, height: 2160 }"
                      :max-size-k-b="{ json: 500, image: 300 }"
                      @file-uploaded="updateKey($event, '1080x2160')"
                    />
                    <div v-if="getPreviewAttachment('1080x2160')" class="mt-2">
                      <div
                        class="preview-container"
                        v-if="splashScreen && isImageKey('1080x2160')"
                      >
                        <img
                          :src="getPreviewAttachment('1080x2160')"
                          alt="1080x2160 preview"
                          class="key-preview-image"
                        />
                      </div>
                      <b-button
                        class="mt-1"
                        variant="outline-primary"
                        size="sm"
                        @click="viewAttachment('1080x2160')"
                      >
                        View 1080x2160
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <!-- 1080x2340 Upload -->
                <b-col md="6">
                  <div class="mb-3">
                    <label class="form-label">1080x2340</label>
                    <FileUpload
                      ref="fileUploadRef1080x2340"
                      :allowed-extensions="allowedExtensions"
                      :size="{ width: 1080, height: 2340 }"
                      :max-size-k-b="{ json: 500, image: 300 }"
                      @file-uploaded="updateKey($event, '1080x2340')"
                    />
                    <div v-if="getPreviewAttachment('1080x2340')" class="mt-2">
                      <div
                        class="preview-container"
                        v-if="splashScreen && isImageKey('1080x2340')"
                      >
                        <img
                          :src="getPreviewAttachment('1080x2340')"
                          alt="1080x2340 preview"
                          class="key-preview-image"
                        />
                      </div>
                      <b-button
                        class="mt-1"
                        variant="outline-primary"
                        size="sm"
                        @click="viewAttachment('1080x2340')"
                      >
                        View 1080x2340
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <!-- 1080x2400 Upload -->
                <b-col md="6">
                  <div class="mb-3">
                    <label class="form-label">1080x2400</label>
                    <FileUpload
                      ref="fileUploadRef1080x2400"
                      :allowed-extensions="allowedExtensions"
                      :size="{ width: 1080, height: 2400 }"
                      :max-size-k-b="{ json: 500, image: 300 }"
                      @file-uploaded="updateKey($event, '1080x2400')"
                    />
                    <div v-if="getPreviewAttachment('1080x2400')" class="mt-2">
                      <div
                        class="preview-container"
                        v-if="splashScreen && isImageKey('1080x2400')"
                      >
                        <img
                          :src="getPreviewAttachment('1080x2400')"
                          alt="1080x2400 preview"
                          class="key-preview-image"
                        />
                      </div>
                      <b-button
                        class="mt-1"
                        variant="outline-primary"
                        size="sm"
                        @click="viewAttachment('1080x2400')"
                      >
                        View 1080x2400
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <ZonesSearch
              label="Search zones"
              :clearable="false"
              :placeholder="
                `${splashScreen ? `Old value: ${splashScreen.zone}` : ''}`
              "
              @zone-selected="($event) => (formData.zone = $event)"
            />
          </b-col>
          <b-col md="6">
            <validation-provider name="Start Date" rules="required">
              <b-form-group
                slot-scope="{ errors }"
                label="Start Date"
                label-for="start-date"
              >
                <flat-pickr
                  id="start-date"
                  v-model="formData.start_datetime"
                  class="form-control"
                  :config="{
                    enableTime: true,
                    minDate: new Date(),
                    allowInvalidPreload: true,
                    minuteIncrement: 1,
                  }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider name="End Date" rules="required">
              <b-form-group
                slot-scope="{ errors }"
                label="End Date"
                label-for="end-date"
              >
                <flat-pickr
                  id="end-date"
                  v-model="formData.end_datetime"
                  class="form-control"
                  :config="{
                    enableTime: true,
                    minDate: new Date(),
                    allowInvalidPreload: true,
                    minuteIncrement: 1,
                  }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <b-form-group label="Type">
              <b-form-select
                v-model="formData.type"
                :options="[
                  { value: 'drivers', text: 'Drivers' },
                  { value: 'users', text: 'Users' },
                ]"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Is Default">
              <b-form-checkbox v-model="formData.is_default" switch />
              <small v-if="formData.is_default" class="text-info">
                Only images (jpg, jpeg, png) are allowed when is default is
                selected
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BRow,
  BCol,
  BFormCheckbox,
  BFormSelect,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { ref, computed } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";
import {
  errorNotification,
  successNotification,
} from "@/utils/toast-notifications";
import FileUpload from "@/views/marketing/advertisements/components/FileUpload.vue";
import ZonesSearch from "@/views/zones/components/ZonesSearch.vue";
import axiosIns from "@/libs/axios";

export default {
  components: {
    flatPickr,
    BCard,
    BFormGroup,
    ZonesSearch,
    FileUpload,
    BRow,
    BCol,
    BFormCheckbox,
    BFormSelect,
    BSpinner,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    splashScreen: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const previewAttachments = ref({});
    const formData = ref({
      zone: "",
      start_datetime: "",
      end_datetime: "",
      keys: [],
      is_default: false,
      type: "drivers",
    });
    const formRef = ref(null);

    const fileUploadRef1080x1920 = ref(null);
    const fileUploadRef1080x2160 = ref(null);
    const fileUploadRef1080x2340 = ref(null);
    const fileUploadRef1080x2400 = ref(null);
    const submitting = ref(false);

    // Computed property for allowed extensions based on is_default
    const allowedExtensions = computed(() => {
      return formData.value.is_default
        ? ["jpg", "jpeg", "png"]
        : ["jpg", "jpeg", "png", "json"];
    });

    // Helper function to get preview attachment for a specific size
    const getPreviewAttachment = (size) => {
      // First check if we have a preview attachment (from new uploads)
      if (previewAttachments.value[size]) {
        return previewAttachments.value[size];
      }
      // Then check if we have an existing key for this size
      const keyObj = formData.value.keys.find((k) => k.size === size);
      return keyObj ? keyObj.key : null;
    };

    // Helper function to update keys array
    const updateKey = (key, size) => {
      const extension = key.includes(".json") ? "json" : "image";

      // Validate: if is_default is true, reject JSON files
      if (formData.value.is_default && extension === "json") {
        errorNotification(
          "Only images should be allowed when is default is selected"
        );
        return;
      }

      const existingIndex = formData.value.keys.findIndex(
        (k) => k.size === size
      );

      if (existingIndex >= 0) {
        formData.value.keys[existingIndex].key = key;
        formData.value.keys[existingIndex].extension = extension;
      } else {
        formData.value.keys.push({ key, size, extension });
      }
    };

    // Helper function to check if a key is an image
    const isImageKey = (size) => {
      const keyObj = formData.value.keys.find((k) => k.size === size);
      if (keyObj && keyObj.extension) {
        return keyObj.extension !== "json";
      }
      // Fallback: check URL extension
      const attachment = getPreviewAttachment(size);
      if (attachment) {
        return !attachment.includes(".json");
      }
      return false;
    };

    // Helper function to view attachment for a specific size
    const viewAttachment = (size) => {
      const attachment = previewAttachments.value[size];
      if (attachment) {
        window.open(attachment);
      } else {
        // Check if we have a key for this size from existing data
        const keyObj = formData.value.keys.find((k) => k.size === size);
        if (keyObj && keyObj.key) {
          window.open(keyObj.key);
        }
      }
    };

    const submitForm = async () => {
      const valid = await formRef.value.validate();
      if (!valid) return;

      // Validate: if is_default is true, ensure no JSON files are present
      if (formData.value.is_default) {
        const hasJsonFiles = formData.value.keys.some(
          (keyObj) => keyObj.extension === "json"
        );
        if (hasJsonFiles) {
          errorNotification(
            "Cannot submit: Only images are allowed when 'Is Default' is selected. Please remove JSON files."
          );
          return;
        }
      }

      try {
        submitting.value = true;
        if (props.splashScreen) {
          await axiosIns.patch(
            `/drivers/splash-screen/${props.splashScreen.id}`,
            {
              zone: formData.value.zone || props.splashScreen.zone,
              start_datetime: new Date(
                formData.value.start_datetime
              ).toISOString(),
              end_datetime: new Date(formData.value.end_datetime).toISOString(),
              keys:
                formData.value.keys.length > 0
                  ? formData.value.keys
                  : props.splashScreen.keys,
              is_default: formData.value.is_default,
              type: formData.value.type,
            }
          );
          successNotification("Successfully updated");
        } else {
          if (formData.value.zone === "") {
            errorNotification("Zone is required");
            return;
          }
          await axiosIns.post("/drivers/splash-screen/create", {
            zone: formData.value.zone,
            start_datetime: new Date(
              formData.value.start_datetime
            ).toISOString(),
            end_datetime: new Date(formData.value.end_datetime).toISOString(),
            keys: formData.value.keys,
            is_default: formData.value.is_default,
            type: formData.value.type,
          });
          successNotification("Successfully created");
        }
        ctx.root.$bvModal.hide("splash-screen-form");
        ctx.emit("done");
      } catch (err) {
        const msg = err?.response?.data?.error?.error || "An error occured";
        errorNotification(msg);
      } finally {
        submitting.value = false;
      }
    };

    const shownHandler = async () => {
      // Clear everything first
      previewAttachments.value = {};

      if (props.splashScreen) {
        // Set form data in a single update to minimize reactive triggers
        formData.value = {
          zone: "",
          start_datetime: props.splashScreen.start_datetime,
          end_datetime: props.splashScreen.end_datetime,
          is_default: props.splashScreen.is_default,
          type: props.splashScreen.type || "drivers",
          keys: [],
        };

        // Handle both old single key format and new keys array format
        if (
          props.splashScreen.keys &&
          props.splashScreen.keys.length &&
          Array.isArray(props.splashScreen.keys)
        ) {
          // Ensure each key object has the extension property
          formData.value.keys = props.splashScreen.keys.map((keyObj) => ({
            ...keyObj,
            extension:
              keyObj.extension ||
              (keyObj.key && keyObj.key.includes(".json") ? "json" : "image"),
          }));
          // Set preview attachments for existing keys
          const newPreviewAttachments = {};
          props.splashScreen.keys.forEach((keyObj) => {
            if (keyObj.key) {
              newPreviewAttachments[keyObj.size] = keyObj.key;
            }
          });
          previewAttachments.value = newPreviewAttachments;
        } else if (props.splashScreen.key) {
          // Backward compatibility for old single key format
          const extension = props.splashScreen.key.includes(".json")
            ? "json"
            : "image";
          formData.value.keys = [
            { key: props.splashScreen.key, size: "1080x1920", extension },
          ];
          if (props.splashScreen.image) {
            previewAttachments.value = {
              "1080x1920": props.splashScreen.image,
            };
          }
        }
      } else {
        // Reset form for new splash screen
        formData.value = {
          zone: "",
          start_datetime: "",
          end_datetime: "",
          keys: [],
          is_default: false,
          type: "drivers",
        };
      }
    };

    const hiddenHandler = () => {
      // Clear preview attachments to prevent caching issues
      previewAttachments.value = {};
      // Reset form data
      formData.value = {
        zone: "",
        start_datetime: "",
        end_datetime: "",
        keys: [],
        is_default: false,
        type: "drivers",
      };
    };

    return {
      previewAttachments,
      formRef,
      shownHandler,
      hiddenHandler,
      fileUploadRef1080x1920,
      fileUploadRef1080x2160,
      fileUploadRef1080x2340,
      fileUploadRef1080x2400,
      submitting,
      submitForm,
      formData,
      required,
      updateKey,
      getPreviewAttachment,
      viewAttachment,
      isImageKey,
      allowedExtensions,
    };
  },
};
</script>

<style scoped>
.preview-container {
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  padding: 12px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.key-preview-image {
  max-width: 100px;
  max-height: 60px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
